import React from "react";
import Header from "../../Components/Header";
import Feature from "../../Components/Feature";
import Footer from "../../Components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import OrderListRight from "../Layouts/OrderListRight";



export default function OrderList() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <OrderListRight />

       </div>
      </div>


      <Feature />
      <Footer />
    </div>
  );
}